import React from 'react'
import { CFView, CFImage, DefaultScreen, MobileScreen } from 'components'
import { mobilePromotion, promotions, promotionImage } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          <CFImage src={promotionImage} w="100%" alt="Mobile Promotions" />
          <CFImage src={mobilePromotion} w="100%" alt="Mobile Promotions" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center maxWidth="1400px">
          <CFView
            h="500px"
            w="100%"
            image={`url(${promotionImage}) center / cover no-repeat`}
            style={{ backgroundAttachment: 'fixed' }}
            column
          ></CFView>
          <CFImage src={promotions} w="100%" alt="Promotions" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
